/**
 * Utility functions for iframe operations
 */
export default class IframeUtil {
  /**
   * Normalize domain to ensure consistency between localhost and 127.0.0.1
   * @param url - The URL to normalize
   * @returns Normalized URL with consistent domain
   */
  static normalizeDomain(url: string): string {
    // Replace 127.0.0.1 with localhost for consistency
    return url.replace(/127\.0\.0\.1/g, 'localhost');
  }

  /**
   * Safely access iframe content with CORS error handling
   * @param iframeRef - Reference to the iframe element
   * @param property - Property name to access from iframe's contentWindow
   * @returns The property value or null if access fails
   */
  static safeAccessIframeContent(iframeRef: React.RefObject<HTMLIFrameElement>, property: string): any {
    try {
      // @ts-ignore
      return iframeRef.current?.contentWindow?.[property];
    } catch (error) {
      console.warn(`Cannot access iframe property '${property}' due to CORS policy:`, error);
      return null;
    }
  }

  /**
   * Check if two origins are the same after domain normalization
   * @param origin1 - First origin to compare
   * @param origin2 - Second origin to compare
   * @returns True if origins are the same after normalization
   */
  static isSameOrigin(origin1: string, origin2: string): boolean {
    return this.normalizeDomain(origin1) === this.normalizeDomain(origin2);
  }
}
